/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Voice_PlaybackInputs */

const en_settings_v2_voice_playback = /** @type {(inputs: Settings_V2_Voice_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice & playback`)
};

const es_settings_v2_voice_playback = /** @type {(inputs: Settings_V2_Voice_PlaybackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz y reproducción`)
};

/**
* | output |
* | --- |
* | "Voice & playback" |
*
* @param {Settings_V2_Voice_PlaybackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_voice_playback = /** @type {((inputs?: Settings_V2_Voice_PlaybackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Voice_PlaybackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_voice_playback(inputs)
	return en_settings_v2_voice_playback(inputs)
});